export const businessData = {
  brand: {
    name: "Shaaira Biocare",
    shortName: "Shaaira",
    legalName: "Shaaira Biocare Private Limited",
    domain: "shaairabiocare.com",
    tagline: "Precision Cosmeceutical & Personal Care Contract Manufacturing",
    description: "Shaaira Biocare supports private-label and contract manufacturing for skin, hair, body, baby and maternity care, men's grooming, suncare, hygiene and curated kits. Starting MOQ: 500–1000 pc, with specifications and production scope confirmed for your project.",
    metaDesc: "Private-label and contract cosmetic manufacturing in India for skin, hair, body, baby care, men's grooming, suncare and kits. MOQ: 500–1000 pc.",
    heroKicker: "Cosmeceutical Contract Manufacturing & R&D Lab",
    heroTitle: "Premium Cosmeceutical Manufacturing.",
    heroSub: "End-to-end custom formulation and private-label production with specification-led development, packaging support, and selected starting MOQs from 500–1000 pc.",
    rangeSub: "Explore nine specialized formulation suites engineered for active stability, sensory excellence, and regulatory compliance.",
    servicesSub: "End-to-end OEM/ODM capabilities spanning active bio-sourcing, vacuum homogenisation, stability testing, and custom packaging.",
    processSub: "A transparent five-phase pathway from technical brief and sampling through approved production, quality release, filling, and dispatch.",
    ctaTitle: "Ready to Formulate Your Next Hero Product?",
    ctaSub: "Share your intended product, benchmark, packaging direction, and target batch. Our team will review the brief and respond with the relevant next steps.",
    foundingYear: 2023,
    gstin: "GSTIN-PENDING",
    logo: "/assets/logos/shaaira-biocare-logo-icon.svg",
    ogImage: "/og-lab-v2.jpg",
    favicon: "/flask-favicon.svg",
  },
  contact: {
    phone: "+91 76967 71693",
    phoneRaw: "917696771693",
    whatsapp: "917696771693",
    email: "info@shaairabiocare.com",
    address: {
      street: "Village Dugghri, Sidhwan Canal Highway, near Mount International School",
      city: "Dugghri (Payal)",
      state: "Punjab",
      postalCode: "141421",
      country: "IN",
      full: "Village Dugghri, Sidhwan Canal Highway, near Mount International School, Punjab 141421, India"
    },
    hours: ["Mo-Sa 09:00-18:00", "Su Closed"],
    mapsUrl: "https://www.google.com/maps/place/Shaaira+Biocare+%7C+Cosmetic+Manufacturing/@30.7955936,75.9531454,17z",
    geo: { lat: 30.7955936, lng: 75.9531454 },
    social: {
      instagram: "https://instagram.com/shaairabiocare",
      linkedin: "https://linkedin.com/company/shaaira-biocare",
      facebook: "https://facebook.com/shaairabiocare",
      youtube: "https://youtube.com/@shaairabiocare"
    }
  },
  topBarTicker: [
    { text: "ISO 9001:2015 & GMP-Aligned Facility", icon: "shield", bold: "ISO 9001:2015 & GMP-Aligned" },
    { text: "14-Day Sample Turnaround", icon: "clock", bold: "14-Day" },
    { text: "Low 500–1000 pc MOQs", icon: "box", bold: "Low 500–1000 pc" }
  ],
  stats: [
    { value: 140, suffix: "+", label: "Tested Formulations" },
    { value: 500, suffix: "–1000 pc", label: "MOQ" },
    { value: 14, suffix: " days", label: "R&D Sample Dispatch" },
    { value: 7, suffix: "", label: "Formulation Suites" }
  ],
  heroHighlights: [
    { icon: "shield", title: "Analytical QC", subtitle: "CoA with every batch" },
    { icon: "box", title: "Flexible MOQs", subtitle: "Start from 500–1000 pc" },
    { icon: "truck", title: "Planned Production", subtitle: "Timeline confirmed per brief" }
  ],
  services: [
    {
      id: "private-label",
      title: "Turnkey Private Label Manufacturing",
      body: "Turnkey contract manufacturing for beauty and wellness brands, spanning ingredient sourcing, controlled processing, filling, secondary packaging, and the applicable product documentation.",
      specs: "Selected MOQs from 500–1000 pc | Timeline confirmed per brief | ISO 9001:2015 & GMP-Aligned",
      icon: "factory"
    },
    {
      id: "contract-manufacturing",
      title: "Custom Formula Scale-Up & Toll Manufacturing",
      body: "Seamless scale-up of your proprietary formulations from bench-top samples to multi-ton production batches. Equipped with vacuum homogenizers delivering 0.2–5 micron micro-droplet stability.",
      specs: "Viscosity Range: 100 to 150,000 cPs | Particle Size: < 5µm | Viscosity & pH Control",
      icon: "gear"
    },
    {
      id: "formulation-rnd",
      title: "Bio-Active Cosmeceutical R&D",
      body: "Custom formulation development for high-efficacy treatments: multi-weight Hyaluronic Acid complexes, micro-encapsulated Retinoids, Niacinamide barrier gels, and lipid-replenishing Ceramide matrices aligned to pH 4.5–5.5 skin mantles.",
      specs: "Active Payload Loading up to 15% | Micro-encapsulation | Skin Mantle Alignment",
      icon: "flask"
    },
    {
      id: "packaging",
      title: "Primary & Secondary Packaging Integration",
      body: "Comprehensive packaging solutions tailored to active ingredient stability. Includes airless bottles to prevent active oxidation, UV-blocking amber dropper bottles, barrier laminate tubes, and eco-conscious PCR plastics.",
      specs: "Airless Technology | Amber Droppers | Aluminium & PCR Laminates",
      icon: "box"
    },
    {
      id: "quality-assurance",
      title: "Analytical QC & ICH Stability Testing",
      body: "Quality plans are agreed against the product specification and intended market. They can include pH, viscosity, microbial-limit, stability, compatibility, or other product-specific checks, with release documentation defined before production.",
      specs: "Defined Release Specification | Agreed Testing Scope | Batch Documentation",
      icon: "shield"
    },
    {
      id: "regulatory-support",
      title: "Indian & International Regulatory Documentation",
      body: "Documentation support can cover INCI ingredient lists, agreed testing records, label review, and market-specific files for domestic or export readiness. The exact scope is confirmed for each product and destination.",
      specs: "Indian cosmetic licensing support | INCI review | MoCRA & EU dossier support",
      icon: "doc"
    }
  ],
  categories: [
    {
      id: "skin-care",
      title: "Advanced Skin Care",
      tagline: "Clinical serums, barrier repair creams, treatments & gentle cleansers.",
      image: "/assets/categories/skin-care-v2.jpg",
      href: "/skin-care",
      icon: "sparkle"
    },
    {
      id: "hair-care",
      title: "Scalp & Hair Therapeutics",
      tagline: "Sulphate-free shampoos, peptide scalp serums & botanical oils.",
      image: "/assets/categories/hair-care-v2.jpg",
      href: "/hair-care",
      icon: "hair"
    },
    {
      id: "body-care",
      title: "Body & Dermal Wellness",
      tagline: "Niacinamide body lotions, AHA body scrubs & rich botanical wraps.",
      image: "/assets/categories/body-care-v2.jpg",
      href: "/body-care",
      icon: "drop"
    },
    {
      id: "baby-mom-care",
      title: "Pediatric & Maternity Care",
      tagline: "Hypoallergenic, tear-free pediatric & maternity barrier treatments.",
      image: "/assets/categories/baby-mom-care-v2.jpg",
      href: "/baby-mom-care",
      icon: "baby"
    },
    {
      id: "men-range",
      title: "Men's Grooming & Performance",
      tagline: "Matte-finish face moisturizers, beard growth serums & post-shave gels.",
      image: "/assets/categories/men-range-v2.jpg",
      href: "/men-range",
      icon: "male"
    },
    {
      id: "other-care",
      title: "Suncare & Personal Hygiene",
      tagline: "Broad-spectrum SPF 50 sunscreens, roll-on deodorants & intimate washes.",
      image: "/assets/categories/other-care-v2.jpg",
      href: "/other-care",
      icon: "sun"
    },
    {
      id: "oral-care",
      title: "Oral & Dental Hygiene",
      tagline: "Nano-HA pastes, charcoal toothpastes & alcohol-free mouthwashes.",
      image: "/assets/categories/oral-care-v2.jpg",
      href: "/oral-care",
      icon: "tooth"
    },
    {
      id: "pet-care",
      title: "Pet Grooming & Dermal Care",
      tagline: "Pet-pH shampoos, neem sprays & lick-conscious paw balms.",
      image: "/assets/categories/pet-care-v2.jpg",
      href: "/pet-care",
      icon: "paw"
    },
    {
      id: "kits",
      title: "Curated Bundles & Travel Sets",
      tagline: "Custom packaged retail discovery sets & seasonal gifting collections.",
      image: "/assets/categories/kits-v2.jpg",
      href: "/kits",
      icon: "gift"
    }
  ].filter((category) => !["oral-care", "pet-care"].includes(category.id)),
  categoryProducts: {
    "skin-care": [
      "15% Ethyl Ascorbic Acid Serum",
      "10% Niacinamide + Zinc Gel",
      "Ceramide NP Barrier Cream",
      "2% Salicylic Acid Blemish Cleanser",
      "CICA Calming Hydrogel",
      "Peptide + Caffeine Eye Cream"
    ],
    "hair-care": [
      "3% Redensyl + Anagain Growth Serum",
      "Sulphate-Free Argan Oil Shampoo",
      "Keratin & Silk Protein Conditioner",
      "Scalp Exfoliating AHA Scrub",
      "Cold-Pressed Rosemary Hair Elixir"
    ],
    "body-care": [
      "5% Lactic Acid Smoothing Body Lotion",
      "Raw Coffee & Vitamin E Body Scrub",
      "Ultra-Rich Shea Butter Cream",
      "Hyaluronic Acid Hydrating Body Wash",
      "Niacinamide Glowing Body Oil"
    ],
    "baby-mom-care": [
      "Colloidal Oat Hydrating Baby Lotion",
      "15% Zinc Oxide Diaper Barrier Cream",
      "Cold-Pressed Virgin Coconut Baby Oil",
      "Tear-Free Gentle Baby Wash & Shampoo",
      "Centella Stretch Mark Oil for Moms"
    ],
    "oral-care": [
      "Nano-Hydroxyapatite Remineralizing Paste",
      "Activated Charcoal Detox Toothpaste",
      "Neem & Clove Herbal Oral Gel",
      "Alcohol-Free Mint Probiotic Mouthwash"
    ],
    "men-range": [
      "Oil-Control Charcoal Face Wash",
      "5% Niacinamide Matte Moisturizer",
      "Beard Growth Serum with Biotin",
      "Soothing Aloe Post-Shave Gel",
      "Volcanic Clay Hair Styling Paste"
    ],
    "pet-care": [
      "Colloidal Oatmeal Pet Shampoo (pH 7.0)",
      "Neem & Tea Tree Anti-Tick Spray",
      "Shea Butter & Beeswax Paw Healing Balm",
      "Deodorizing Coat Gloss Spray"
    ],
    "other-care": [
      "Hybrid SPF 50 PA++++ Invisible Sunscreen",
      "Aluminium-Free AHA Roll-On Deodorant",
      "Lactic Acid pH-Balanced Intimate Wash",
      "Moisturizing Aloe Vera Hand Sanitizer"
    ],
    "kits": [
      "3-Step Glass Skin Discovery Set",
      "Anti-Hairfall Scalp Regimen Kit",
      "Travel Mini Essentials Pouch",
      "Luxury Spa Gifting Collection"
    ]
  },
  batchEstimator: {
    tiers: [
      { units: 500, label: "500 Units (Pilot Trial)", leadDays: "Confirmed after brief", sampling: "Target: within 14 days", qcLevel: "Specification-led release checks", packaging: "Stock pack options where compatible" },
      { units: 2500, label: "2,500 Units (Launch Batch)", leadDays: "Confirmed after brief", sampling: "Target: within 14 days", qcLevel: "Agreed CoA and testing scope", packaging: "Label, print, and decoration options" },
      { units: 10000, label: "10,000 Units (Scale-Up)", leadDays: "Production plan required", sampling: "Pilot approval before scale-up", qcLevel: "Market- and product-specific test plan", packaging: "Custom component sourcing where viable" },
      { units: 50000, label: "50,000+ Units (Enterprise)", leadDays: "Production plan required", sampling: "Dedicated pilot and approval pathway", qcLevel: "Agreed documentation and release testing", packaging: "Custom tooling and direct sourcing review" }
    ]
  },
  regulatory: [
    { code: "INDIA MARKET", title: "Licensing & Label Support", desc: "Support for applicable Indian cosmetic licensing, ingredient declarations, label review, and product documentation is scoped against the product category and route to market." },
    { code: "ISO 9001:2015 / GMP", title: "Quality-Managed Manufacturing", desc: "GMP-aligned production controls, documented cleaning and batch procedures, in-process checks, and defined release specifications support repeatable manufacturing." },
    { code: "STABILITY", title: "Agreed Stability Programme", desc: "Stability work is scoped to the formulation, packaging system, target shelf life, and destination-market requirements before commercial production." },
    { code: "INCI & EXPORT", title: "Market-Ready Documentation", desc: "Support can include standardized INCI declarations and the agreed product, packaging, and testing records for the intended domestic or export market." }
  ],
  actives: [
    { name: "Niacinamide (Vitamin B3)", category: "Skin Barrier & Sebum Control", optimumPh: "5.0 - 6.0", maxLoad: "10.0%", benefits: "Strengthens stratum corneum, reduces sebum excretion rate, fades hyperpigmentation." },
    { name: "Ethyl Ascorbic Acid (Vitamin C)", category: "Antioxidant & Radiance", optimumPh: "4.0 - 5.5", maxLoad: "15.0%", benefits: "Highly stable Vitamin C ether derivative. Resists oxidation in airless packaging while inhibiting tyrosinase." },
    { name: "Salicylic Acid (BHA)", category: "Comedolytic & Exfoliation", optimumPh: "3.5 - 4.2", maxLoad: "2.0%", benefits: "Lipophilic beta-hydroxy acid that penetrates follicular pores to dissolve sebum plugs and cellular debris." },
    { name: "Ceramide NP + AP + EOP Complex", category: "Lipid Replenishment", optimumPh: "5.0 - 6.5", maxLoad: "3.0%", benefits: "Identical skin-barrier lipids combined with Phytosphingosine to repair damaged intercellular lipid matrix." },
    { name: "Redensyl + Anagain Complex", category: "Trichology & Hair Density", optimumPh: "5.5 - 6.5", maxLoad: "3.5%", benefits: "Targets ORS stem cells and dermal papilla fibroblasts to reactivate hair growth cycle and decrease hair shedding." },
    { name: "Colloidal Oatmeal USP", category: "Anti-Inflammatory Dermal Soothing", optimumPh: "5.5 - 7.0", maxLoad: "5.0%", benefits: "Rich in Beta-Glucan and Avenanthramides. Calms pediatric eczema, pruritus, and irritated canine skin." }
  ],
  process: [
    { step: 1, title: "Brief & Target Active Mapping", body: "Define target consumer, preferred benchmark product, active percentage requirements, and benchmark budget. An initial technical review follows before sampling begins." },
    { step: 2, title: "Lab Formulation & Sample Dispatch", body: "Our R&D chemists prepare bench-top samples and refine viscosity, skin feel, fragrance direction, and other agreed attributes until the client approves the development sample." },
    { step: 3, title: "Costing, Packaging & Documentation Review", body: "Transparent itemized quotation per unit, final MOQ confirmation, packaging compatibility checks, and review of the applicable regulatory documentation." },
    { step: 4, title: "Controlled Batch Production & QC", body: "Controlled mixing and homogenization are followed by the agreed pH, viscosity, microbial-limit, and release checks for the formulation." },
    { step: 5, title: "Inline Filling, Labelling & CoA Dispatch", body: "Automatic filling under laminar airflow, precision batch coding, shrink wrapping, and shipping with Certificate of Analysis (CoA) and batch manufacturing records." }
  ],
  // Publish verified customer proof only. Testimonials are intentionally empty
  // until the business supplies approved names, roles, and quotes.
  testimonials: [] as Array<{ quote: string; name: string; role: string; initials: string }>,
  faqs: [
    { q: "What are your Minimum Order Quantities (MOQs)?", a: "Our MOQ starts at just 500–1000 pc per SKU for standard stock packaging, making it ideal for emerging D2C beauty brands testing new formulations. For custom packaging componentry or bespoke molded jars, MOQs typically start at 2,500–5,000 units." },
    { q: "Can you manufacture formulations using our custom active ingredients?", a: "Yes. We accept client-supplied proprietary ingredients (such as patented botanical extracts or specialized peptide complexes) subject to safety data sheet (SDS) review and lab compatibility testing." },
    { q: "What quality control testing is performed on each batch?", a: "Every production batch undergoes analytical testing in our QC lab: pH balance verification, viscosity measurement, specific gravity, organoleptic testing, and microbial limit testing (Total Viable Count, Yeast & Mold). A signed Certificate of Analysis (CoA) accompanies every dispatch." },
    { q: "Do you provide regulatory licensing support for selling in India and exporting?", a: "Yes. Support can include applicable Indian cosmetic licensing documentation, product label and INCI review, and agreed export documentation for markets such as the United States or European Union. The exact scope is confirmed for each product and destination market." },
    { q: "How long does formulation sampling and mass production take?", a: "Our target turnaround for an approved formulation brief is within 14 business days for the first R&D sample. Once you approve the sample, mass batch production and inline filling typically require 18–21 business days, depending on packaging component lead times." },
    { q: "Can you handle custom primary and secondary packaging?", a: "Yes. We work with airless pump bottles, glass droppers, aluminium tubes, PCR plastic bottles, and luxury unit cartons. We also offer screen printing, hot foil stamping, and pressure-sensitive labelling." }
  ]
};
